import styled, { css } from 'styled-components'

export const FormContent = styled.div`
  max-width: 950px;
  margin: 15px auto 20px;
  padding-top: 20px;
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
`

export const ButtonColumn = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 220px;
  margin-top: 20px;
  margin-left: -195px;
`
